import { getDomain } from "../../utils/helpers.js";
import store from "@/store";
export function dateTimeCountdown(dataTime) {
  const currentTime = new Date().getTime();
  const distance = dataTime - currentTime;

  const absDistance = Math.abs(distance);
  const days = Math.floor(absDistance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (absDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((absDistance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((absDistance % (1000 * 60)) / 1000);

  const timeStr = `${days ? days + " days" : ""} ${
    hours ? hours + " hours" : ""
  }  ${minutes} minutes`;

  if (distance >= 0) {
    return `In ${timeStr}`;
  } else {
    return `Delay by ${timeStr}`;
  }
}

export function getETA(request) {
  const displayValue = request.dueByTimeDisplayValue;
  if (request.statusName == "Closed" || !displayValue) {
    return displayValue;
  }
  return `${dateTimeCountdown(request.dueByTimeValue)} / ${displayValue}`;
}

export async function loadFile(file) {
  console.log("file " + file);
  const previewTab = window.open("", "_blank");
  if (!previewTab) return;
  previewTab.document.write("Loading attachment...");

  const url =
    getDomain() +
    `/api/manageengine/GetAttachments?url=${encodeURIComponent(
      file.content_url
    )}`;
  try {
    const response = await fetch(url, {
      headers: {
        authorization: `${$cookies.get("user-token")}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load attachment. Status: ${response.status}`);
    }

    const blob = await response.blob();
    const headerType = (response.headers.get("content-type") || "")
      .split(";")[0]
      .trim()
      .toLowerCase();
    const blobType = (blob.type || "").toLowerCase();
    const fileName = (file.name || "").toLowerCase();
    const ext = fileName.includes(".") ? fileName.split(".").pop() : "";
    const imageExts = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
    const isImage =
      headerType.startsWith("image/") ||
      blobType.startsWith("image/") ||
      imageExts.includes(ext);

    const objectUrl = URL.createObjectURL(blob);

    if (isImage) {
      previewTab.document.open();
      previewTab.document.write(`
          <html>
            <head><title>${file.name || "Attachment"}</title></head>
            <body style="margin:0;background:#111;display:flex;align-items:center;justify-content:center;min-height:100vh;">
              <img src="${objectUrl}" alt="attachment" style="max-width:100%;max-height:100vh;object-fit:contain;" />
            </body>
          </html>
        `);
      previewTab.document.close();
    } else {
      previewTab.location.href = objectUrl;
    }

    setTimeout(() => URL.revokeObjectURL(objectUrl), 2 * 60 * 1000);
  } catch (error) {
    previewTab.close();
    console.error("Failed to preview attachment", error);
  }
}

export function isTechnician() {
  const roles = store.getters["authentication/getRoles"];
  const isTech = roles.includes("Technician");
  return isTech;
}

export function isAdmin() {
  const isAdmin = store.getters["authentication/isAdmin"];
  if (!isAdmin || isAdmin == "false") return false;
  return true;
}

export function getStatusIcon(request) {
  if (!request || !request.statusName) return;
  return statusIcon(request.statusName);
}

export function statusIcon(value) {
  const options = {
    Closed: "mdi-check-circle",
    Open: "mdi-clock",
    Reopened: "mdi-clock",
    "On Hold": "mdi-clock",
    Canceled: "mdi-cancel",
  };
  return options[value] || "";
}

export function getStatusIconColor(request) {
  if (!request || !request.statusName) return;
  return statusIconColor(request.statusName);
}

export function statusIconColor(value) {
  const options = {
    Closed: "#2ecc71",
    Open: "#f1c40f",
    Reopened: "#f1c40f",
    "On Hold": "#3498db",
    Canceled: "#e74c3c",
  };
  return options[value] || "#bdc3c7";
}

export function getClosedInfo(request) {
  if (!request || !request.statusName) return;
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  if (!request.lastUpdatedTime) {
    return;
  }
  if (request.statusName != "Closed") {
    let lastUpdatedTime = new Date(request.lastUpdatedTime);
    return `Last updated on ${lastUpdatedTime.toLocaleDateString(
      "en-US",
      options
    )} at ${lastUpdatedTime.toLocaleTimeString()} `;
  }
  let completedTime = new Date(request.completedTime);
  return `Closed on ${completedTime.toLocaleDateString(
    "en-US",
    options
  )} at ${completedTime.toLocaleTimeString()}`;
}

export function getPriority(priorityName) {
  const priorityMap = {
    "1 High": "High",
    "3 Option 8": "High",
    "2 Normal": "Normal",
    "4 Low": "Low",
  };
  return priorityMap[priorityName];
}

export function getPriorityColor(priorityName) {
  const priorityMap = {
    "1 High": "#e74c3c",
    "3 Option 8": "#e74c3c",
    "2 Normal": "#f39c12",
    "4 Low": "#7f8c8d",
  };
  return priorityMap[priorityName];
}

export function isAudioFile(fileName) {
  const audioExtensions = [".mp3", ".wav", ".ogg", ".m4a"];
  return audioExtensions.some((ext) => fileName.toLowerCase().endsWith(ext));
}

export function getAudioSrc(file) {
  return `${getDomain()}/api/manageengine/GetAttachments?url=${
    file.content_url
  }&name=${file.name}`;
}

export function getTechnician(request) {
  if (
    !request ||
    !request.technicianID ||
    request.technicianName == "UserPortal"
  )
    return "This ticket has not yet been assigned";

  return request.technicianName;
}

export const statusClosed = [
  "Closed",
  "Canceled",
  "Filter Decline",
  "Resolved",
];
export const statusOpen = ["Open", "Reopened"];

